module.exports = __webpack_public_path__ + "img/null_log_bottom.ad2bc17d.png";